const initialState = {
  peersToBeSelectedReviewees: [],
  isFetchingReviewees: false,
};

const peerSelectionForReviewee = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_DIRECT_REPORT_REVIEWEES":
      return {
        ...state,
        peersToBeSelectedReviewees: action.payload,
      };
    case "TOGGLE_IS_FETCHING_DIRECT_REPORT_REVIEWEES":
      return {
        ...state,
        isFetchingReviewees: !state.isFetchingReviewees,
      };
    default:
      return state;
  }
};

export default peerSelectionForReviewee;
